module.exports = __webpack_public_path__ + "img/no_content.1248e3ea.png";